import { render, staticRenderFns } from "./bypassComment.vue?vue&type=template&id=2205becf"
import script from "./bypassComment.vue?vue&type=script&lang=js"
export * from "./bypassComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports